module.exports = __webpack_public_path__ + "media/images/arrow-f3c7f4393f8fab0cf200b9258bbe22ae.png";